
export const PageDataState = {
    Searchs: {
        region_name: {
            type: 'text',
            id: 'region_name',
            label: 'ภูมิภาค',
            value: '',
            placeholder: 'ภาค',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'ภูมิภาค',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}